export enum JustifyType {
  Start = "START",
  End = "END",
  Center = "CENTER",
  Stretch = "STRETCH",
}